import { gql } from '@apollo/client';
import { CASE_ID_CONFIGURATION_FIELDS } from '../queries/CaseIdConfigurationQueries';

// Saves the organisation's Case ID format. Rejected server-side for non-admins, for a preset whose
// required fields are disabled, and for a padding change that would not hold an existing ID. Once
// cases exist, a format change also needs confirmFormatChange.
export const UPSERT_CASE_ID_CONFIGURATION = gql`
  mutation upsertCaseIdConfiguration($input: UpsertCaseIdConfigurationInput!) {
    configuration: upsertCaseIdConfiguration(input: $input) {
      ...CaseIdConfigurationFields
    }
  }
  ${CASE_ID_CONFIGURATION_FIELDS}
`;
